<template>
  <div class="ordermain orderbox">
    <headerbox></headerbox>

    <div class="main">
      <hotelhead></hotelhead>
      <div class="container">
        <div class="layout">
          <div v-if="loading" class="loading">
            <!-- 显示加载图片 -->
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="bookinfro">
            <menuTitle :titles="lefttitles"></menuTitle>
            <el-form ref="form">
              <div class="bookdate">
                <div class="datedetail">
                  <p>入住日期</p>
                  <el-form-item>
                    <el-date-picker
                      v-model="checkInDate"
                      type="date"
                      placeholder="选择入住日期"
                      :picker-options="checkInOptions"
                      :format="dateFormat"
                      @change="handleCheckInDateChange"
                      class="custom-input"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="night">{{ dateDiff }}晚</div>
                <div class="datedetail">
                  <p>离店日期</p>
                  <el-form-item>
                    <el-date-picker
                      v-model="checkOutDate"
                      type="date"
                      placeholder="选择离店日期"
                      :picker-options="checkOutOptions"
                      :format="dateFormat"
                      @change="handleCheckOutDateChange"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>

                <div class="roomnum">
                  <p>房间数</p>
                  <el-select
                    v-model="roomvalue"
                    placeholder="1"
                    :click-clear="false"
                  >
                    <el-option
                      v-for="item in roomoptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-form>
          </div>

          <div class="custominfro">
            <menuTitle :titles="custominfro"></menuTitle>

            <div class="customname">
              <h3>客人姓名</h3>
              <p>每间房只需填一位姓名，并且姓名与证件保持一致</p>
            </div>
            <div class="costomlist">
              <ul>
                <li v-for="room in roomList" :key="room">
                  <p>房间{{ room }}</p>
                  <el-input
                    v-model="guestNames[room - 1]"
                    placeholder="只需填一位住客姓名"
                  ></el-input>
                </li>
              </ul>
            </div>
            <div class="customphone">
              <h3>联系手机</h3>
              <el-input
                v-model="guestPhone"
                placeholder="请输入联系电话"
              ></el-input>
            </div>
          </div>

          <div class="custominfro">
            <menuTitle :titles="customTime"></menuTitle>
            <div class="customphone">
              <h3>到店时间</h3>
              <el-select
                v-model="roomIntime"
                placeholder="1"
                popper-class="popper-scrollbar-show"
              >
                <el-option
                  v-for="item in roomtime"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="paybox">
            <div class="paytips">
              您的订单一经确认，不可变更或取消；
              如未能如约入住，将收取全额房费作为违约费用。
            </div>
            <div class="paytotal">
              <p>
                在线支付<span><small>¥</small>{{  Math.round(price * roomvalue)   }}</span>
              </p>
              <div
                @click="submitOrder()"
                :disabled="isSubmitting"
                :class="[buttonClass, { disabled: isSubmitting }]"
                class="paybotton"
              >
                <p>
                  在线支付<span><small>¥</small>{{  Math.round(price * roomvalue)  }}</span>
                </p>
                <i>支付订单</i>
              </div>
            </div>
          </div>
        </div>
        <div class="sides">
          <div class="orderside">
            <div v-if="hotelinfro" class="orderhotel">
              <img
                v-if="hasValidImageUrl"
                :src="roomdetailinfro.img[0].big_imgurl"
                alt=""
              />
              <img v-else :src="roomdetailinfro.ImageUrl" alt="Default Image" />
              <h3>{{ hotelinfro.hotelname }}</h3>
              <p>{{ hotelinfro.address }}</p>
            </div>

            <div v-if="hotelinfro">
              <div class="orderhotel">
                <h3>{{ roomdetailinfro.title }}</h3>
                <p>宽带：{{ roomdetailinfro.adsl }}</p>
                <p>面积：{{ roomdetailinfro.area }}</p>
                <p>床型：{{ roomdetailinfro.bed }}</p>
                <p>楼层：{{ roomdetailinfro.floor }}</p>
              </div>
            </div>
            <div v-if="hotelinfro">
              <div class="orderhotel">
                <h3>房费信息</h3>
                <h4>
                  在线支付
                  <span>¥{{  Math.round(price * roomvalue)  }}</span>
                </h4>

                <!-- <div v-for="dateInfo in plansdateroom.date" :key="dateInfo.day">
                  <p>
                    <span>{{ dateInfo.day }}</span>
                    <span> {{ plansdateroom.planname }}</span>
                    <span> {{ roomvalue }}间 </span>
                    <span> ¥ {{ plansdateroom.totalprice }}</span>
                  </p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerbox></footerbox>
  </div>
</template>

<script>
import { setStorage, getStorage } from "@/common/until/until";
import { AGENT_ID } from "@/common/until/const";
import { gethotelroom, getroom } from "network/home";
import { submittotelroom } from "network/order";
import { MessageBox } from "element-ui";
import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
import menuTitle from "components/content/menuTitle";
import { mapMutations } from "vuex";
import moment from "moment";
import { postHuiyi } from "network/confercence";
export default {
  name: "Order",

  components: {
    footerbox,
    headerbox,
    hotelhead,
    menuTitle,
  },
  data() {
    return {
      righttitles: "在线酒店查询",
      lefttitles: "酒店预订",
      custominfro: "入住信息",
      customTime: "预计到店",
      hotelRoom: [],
      checkInDate: this.$store.state.checkInDateDefult
        ? new Date(this.$store.state.checkInDateDefult)
        : new Date(),
      checkOutDate: this.$store.state.checkOutDateDefult
        ? new Date(this.$store.state.checkOutDateDefult)
        : new Date(new Date().getTime() + 86400000),
      checkInOptions: {
        disabledDate: (date) => {
          return (
            date &&
            (date.valueOf() < Date.now() - 86400000 ||
              (this.checkOutDate &&
                date.valueOf() >= this.checkOutDate.valueOf()))
          );
        },
      },
      checkOutOptions: {
        disabledDate: (date) => {
          return (
            date &&
            (date.valueOf() <= this.checkInDate.valueOf() ||
              date.valueOf() < Date.now() - 86400000)
          );
        },
      },
      dateFormat: "yyyy-MM-dd 周ddd",
      roomoptions: [
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4",
        },
        {
          value: "5",
          label: "5",
        },
        {
          value: "6",
          label: "6",
        },
        {
          value: "7",
          label: "7",
        },
        {
          value: "8",
          label: "8",
        },
        {
          value: "9",
          label: "9",
        },
        {
          value: "10",
          label: "10",
        },
      ],
      roomtime: [
        { value: "14", label: "14:00" },
        { value: "15", label: "15:00" },
        { value: "16", label: "16:00" },
        { value: "17", label: "17:00" },
        { value: "18", label: "18:00" },
        { value: "19", label: "19:00" },
        { value: "20", label: "20:00" },
        { value: "21", label: "21:00" },
        { value: "22", label: "22:00" },
        { value: "23", label: "23:00" },
        { value: "24", label: "24:00" },
      ],
      roomvalue: 1,
      guestNames: [],
      guestPhone: "",
      roomIntime: "14",
      isSubmitting: false,
      buttonClass: "submit",
      roomselect: true,
      loading: false, // 控制加载状态
      currentroom: true,
      UID: "1",
      price: "1",
      price2: "1"
    };
  },
  created() {
    const hid = this.$route.query.hid;
    const tm1 = this.$route.query.tm1;
    const tm2 = this.$route.query.tm2;
     this.price = this.$route.query.price;
      this.price2 = Math.round(this.price / 1.1);

    if (tm1 && tm2) {
      this.checkInDate = new Date(tm1);
      this.checkOutDate = new Date(tm2);
    }
  },

  mounted() {
    this.UID = this.$route.query.uid ? this.$route.query.uid : "1";
  },
  methods: {
    ...mapMutations(["addSelectedPlan"]),
    submitCheckhotel() {
      // this.getHotelRoom();
    },
    book_click(rid, planid) {
      const existingParams = { ...this.$route.query };
      this.UID = this.$route.query.uid ? this.$route.query.uid : "1";
      const newParams = {
        rid: rid, // 新的rid值
        planid: planid, // 新的planid值
        ...existingParams, // 将原来的参数添加到新的参数对象中
      };
      this.$router.push({ path: "/Order", query: newParams });
    },
    handleCheckInDateChange(value) {
      // 仅当离店日期为空或早于入住日期时，才更新为入住日期的下一天
      if (
        !this.checkOutDate ||
        moment(this.checkOutDate).isSameOrBefore(moment(value), "day")
      ) {
        this.checkOutDate = new Date(value.getTime() + 86400000);
      }
      const tm1 = moment(this.checkInDate).format("YYYY-MM-DD");
      const tm2 = moment(this.checkOutDate).format("YYYY-MM-DD");
      const hid =
        this.$route.query.hid || getStorage("cachedId") || "defaultHid";
      this.$store.commit("setCheckInDateDefult", tm1);
      this.$store.commit("setCheckOutDateDefult", tm2);
      console.log(tm1, this.pid);
      this.getHotelRoom(tm1, tm2, hid, this.rid, this.pid);
    },
    handleCheckOutDateChange(value) {
      if (value < this.checkInDate) {
        this.checkOutDate = new Date(this.checkInDate.getTime() + 86400000);
      }
      const tm1 = moment(this.checkInDate).format("YYYY-MM-DD");
      const tm2 = moment(this.checkOutDate).format("YYYY-MM-DD");
      const hid =
        this.$route.query.hid || getStorage("cachedId") || "defaultHid";
      // console.log(tm1, this.pid);
      this.$store.commit("setCheckInDateDefult", tm1);
      this.$store.commit("setCheckOutDateDefult", tm2);
      this.getHotelRoom(tm1, tm2, hid, this.rid, this.pid);
    },

    async getHotelRoom(tm1, tm2, hid, rid, pid) {
      let that = this;
      that.loading = true;
      let urls = "http://81.70.247.104/e/json.php";
      const greenhotelid = [
        1834690, 2602495, 1606783, 2669469, 1881308, 1879993, 2607688, 2672173,
        1979235, 1985723, 1915754, 1788476, 1684158, 2689625, 1780852, 2611180,
        1811671, 2308732, 1652467, 2651287, 1813917, 1839705, 1617655, 2579276,
        1822710, 1836637, 1755133, 1764059, 1789654, 1684239, 2613062, 1814582,
      ];
      for (let i = 0; i < greenhotelid.length; i++) {
        if (greenhotelid[i] == hid) {
          urls = "http://81.70.247.104/e/json.php";
          break; // 找到匹配项后退出循环
        }
      }
      try {
        $.ajax({
          url: urls, // 替换为你的实际 API 端点
          method: "GET",
          dataType: "jsonp",
          data: {
            tm1,
            tm2,
            hid,
            agent_id: AGENT_ID,
          },
          success: function (res) {
            console.log(res);
            that.loading = false;

            that.hotelRoom = res[0].rooms;
            if (res[0].rooms === null) {
              that.isSubmitting = true; // 开始提交
              that.buttonClass = "submitting"; // 设置正在提交的 CSS 类
              MessageBox.alert("该日期内房型无房", "提示", {
                confirmButtonText: "确定",
                type: "info",
              });
            } else {
              const selectedPlan = that.hotelRoom.find(
                (room) => room.RoomId === rid
              );
               console.log(selectedPlan);
              if (selectedPlan == undefined) {
                that.isSubmitting = true; // 开始提交
                that.buttonClass = "submitting"; // 设置正在提交的 CSS 类
                MessageBox.alert("该日期内房型无房", "提示", {
                  confirmButtonText: "确定",
                  type: "info",
                });
              } else {
                const planid = that.$route.query.planid;
                const filteredPlans = selectedPlan.plans.filter(
                  (plans) => plans.planid == planid
                );
                // console.log(filteredPlans.length > 0);
                that.price = selectedPlan.plans[0].totalprice*1.1;
                that.price2= selectedPlan.plans[0].totalprice;
                if (filteredPlans.length > 0) {
                  that.isSubmitting = false; // 开始提交
                  that.buttonClass = ""; // 设置正在提交的 CSS 类
                  that.addSelectedPlan(selectedPlan);
                  setStorage("selectedPlans", JSON.stringify(selectedPlan));
                } else {
                  that.isSubmitting = true; // 开始提交
                  that.buttonClass = "submitting"; // 设置正在提交的 CSS 类
                  MessageBox.alert("该日期内房型无房", "提示", {
                    confirmButtonText: "确定",
                    type: "info",
                  });
                }
              }
            }
          },
        });
      } catch (error) {
        console.error("Error fetching hotel data:", error);
      }
    },
    submitOrder() {
      let that = this;
      // 验证 guestNames 数组必须有值
      if (this.isSubmitting) {
        this.$message.error("请勿提交");
        return; // 正在提交时，不执行重复提交操作
      }

      if (this.guestNames.length === 0) {
        this.$message.error("请输入名字");
        return;
      }
      for (let i = 0; i < this.roomvalue; i++) {
        const guestName = this.guestNames[i];
        // console.log(guestName);
        if (guestName === "" || guestName === undefined) {
          this.$message.error("请填写所有住客的姓名");
          return;
        }
      }
      // 验证 guestPhone 字符串不能为空
      if (this.guestPhone === "") {
        this.$message.error("请输入手机号");
        return;
      }
      const phonePattern = /^1[3456789]\d{9}$/;
      if (!phonePattern.test(this.guestPhone)) {
        this.$message.error("请输入有效的手机号码");
        return;
      }
      this.isSubmitting = true; // 开始提交
      this.buttonClass = "submitting"; // 设置正在提交的 CSS 类
      let data = {
     
        total_money:Math.round(that.price*that.roomvalue),
        price: Math.round(that.price2*that.roomvalue),
        roomname: that.roomdetailinfro.title + " " + that.plansdateroom.planname,
        guest: that.guestNames.join(","),
        mobile: that.guestPhone, //
        tm1: moment(that.checkInDate).format("YYYY-MM-DD"),
        tm2: moment(that.checkOutDate).format("YYYY-MM-DD"),
        id: that.zid,
        roomnum: that.roomvalue,
        breakfast:0

      };
      // console.log(data);
      submittotelroom(data)
        .then((response) => {
          // console.log(response);
          setStorage("guestNames", JSON.stringify(that.guestNames)); //客户的名字存缓存
          if(response.code==200){
          const params = {
            orderid: response.data,
            a: "getorder",
          };
          this.$message.success("提交成功");
          const existingParams = { ...this.$route.query };
          const newParams = {
            ...existingParams,
            orderid:response.data,
          };

            this.$router.push({ path: "/OrderDetail", query: newParams });
          } else{
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
      getWeek(date) {
    const week = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
    return week[new Date(date).getDay()];
  },

  // handleCheckInDateChange(val){
  //   console.log(val);
  // }
  },
  computed: {
    
    dateDiff() {
      const checkInMoment = moment(this.checkInDate).startOf("day");
      const checkOutMoment = moment(this.checkOutDate).startOf("day");
      const diff = checkOutMoment.diff(checkInMoment, "days");
      return diff;
    },
    roomList() {
      // 生成房间号列表
      return Array.from({ length: this.roomvalue }, (_, index) => index + 1);
    },
    hotelinfro() {
      // 从Vuex中获取房间信息
      let roomInfo = this.$store.state.hotelinfro;

      // 如果Vuex中没有房间信息，则从LocalStorage中获取
      if (!roomInfo) {
        const localStorageRoomInfo = localStorage.getItem("hoteldata");
        if (localStorageRoomInfo) {
          roomInfo = JSON.parse(localStorageRoomInfo);
        }
      }
      return roomInfo;
    },
    roomdetailinfro() {
      // 从Vuex中获取房间信息
      const planid = this.$route.query.planid;
      let roomdetailinfro = this.$store.state.selectedPlans
        ? this.$store.state.selectedPlans
        : JSON.parse(localStorage.getItem("selectedPlans")) || null;

      return roomdetailinfro;
    },
    plansdateroom() {
      // const planid = this.pid;
      // // console.log(planid);
      // let roomdetailinfro = this.$store.state.selectedPlans
      //   ? this.$store.state.selectedPlans
      //   : JSON.parse(localStorage.getItem("selectedPlans")) || null;
      // // console.log(roomdetailinfro);
      // const filteredPlans = roomdetailinfro.plans.filter(
      //   (plans) => plans.planid == planid
      // );
      // // console.log(planid);
      // if (filteredPlans.length != 0) {
      //   localStorage.setItem("filteredPlans", JSON.stringify(filteredPlans));
      //   this.currentroom = true;
      // } else {
      //   this.currentroom = false;
      // }

      // return filteredPlans[0];
      const planid = this.pid;
      let roomdetailinfro = this.$store.state.selectedPlans
        ? this.$store.state.selectedPlans
        : JSON.parse(localStorage.getItem("selectedPlans")) || null;
      const filteredPlans = roomdetailinfro.plans.filter(
        (plan) => plan.planid == planid
      );

      if (filteredPlans.length != 0) {
        const modifiedPlan = {
          ...filteredPlans[0],
          totalprice: Math.floor(filteredPlans[0].totalprice * 1.1),
        };
        localStorage.setItem("filteredPlans", JSON.stringify([modifiedPlan]));
        this.currentroom = true;
        return modifiedPlan;
      } else {
        this.currentroom = false;
        return null;
      }
    },
    pid() {
      return this.$route.query.planid;
    },
    zid() {
      const hid =
        this.$route.query.hid ||
        localStorage.getItem("cachedId") ||
        "defaultHid";
      return hid;
    },
    rid() {
      return this.$route.query.rid;
    },
    hasValidImageUrl() {
      // 检查数组对象中是否包含有效的big_imgurl字段
      const planid = this.$route.query.planid;
      let roomdetailinfro = this.$store.state.selectedPlans
        ? this.$store.state.selectedPlans
        : JSON.parse(localStorage.getItem("selectedPlans")) || null;

      if (
        roomdetailinfro &&
        roomdetailinfro.img &&
        roomdetailinfro.img.length > 0
      ) {
        return roomdetailinfro.img[0].hasOwnProperty("big_imgurl");
      } else {
        return false; // 或者根据需求返回其他默认值
      }
    },
    getFormattedPrice() {
      return function (price) {
        const formattedPrice = Math.floor(price * 1.1);
        return formattedPrice;
      };
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  font-size: 16px;
  font-weight: 400;
  color: #180808;
}
.layout {
  position: relative;
}
.loading {
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  span {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: #3498db;
    border-radius: 50%;
    opacity: 0;
    animation: scale 1s ease-in-out infinite;
    animation-delay: 0s, 0.25s, 0.5s; /* 每个元素延迟不同的时间 */
    margin: 0 5px;
  }

  @keyframes scale {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.3;
      transform: scale(0.5);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
}
.ordermain {
  width: 100%;
  background: #f1f1f1;
  .bookinfro {
    background: #fff;
    margin-bottom: 20px;
    padding: 20px 28px;
  }
  .custominfro {
    background: #fff;
    margin-bottom: 20px;
    padding: 20px 28px;
    .customname {
      margin-bottom: 10px;
      h3 {
        font-size: 14px;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #888888;
        line-height: 24px;
      }
    }
    .costomlist ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 30px;
      li {
        width: 30%;
        margin-bottom: 10px;
        border-bottom: 1px solid #dbdbdb;
        ::v-deep .el-input__inner {
          border: none;
          padding-left: 0;
          color: #000;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          color: #444444;
          line-height: 30px;
        }
      }

      li:last-child:nth-child(3n - 1) {
        margin-right: calc(10% / 2 + 30%);
      }
    }

    .customphone {
      width: 30%;
      border-bottom: 1px solid #dbdbdb;
      h3 {
        font-size: 14px;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
      }
      ::v-deep .el-input__inner {
        border: none;
        padding-left: 0;
        color: #000;
      }
    }
  }
  .bookdate {
    display: flex;
    justify-content: space-between;
    .datedetail {
      border-bottom: 1px solid #dbdbdb;
      width: 160px;
    }
    .roomnum {
      width: 160px;
      border-bottom: 1px solid #dbdbdb;
      p {
        font-size: 12px;
        font-weight: 400;
        color: #444444;
        line-height: 30px;
      }
    }
  }
  .el-form {
    .custom-input {
      .el-input__inner {
        border-bottom: 1px solid #dbdbdb;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .datedetail {
      p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #444444;
        line-height: 30px;
      }
    }
    .night {
      display: flex;
      align-items: center;
      font-weight: 400;
      color: #555;
      font-size: 14px;
    }

    ::v-deep .el-input__inner {
      border: none;
      padding-left: 0;
      color: #000;
    }
    ::v-deep .el-input__prefix {
      display: none;
    }
    ::v-deep .el-date-editor {
      width: 160px;
    }
  }

  .paybox {
    background: #fff;
    margin-bottom: 20px;
    padding: 20px 28px;
    .paytips {
      padding: 10px 20px;
      background: #faffe0;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 400;
      color: #494949;
      line-height: 21px;
      margin-bottom: 30px;
    }
    .paytotal {
      display: flex;
      justify-content: space-between;
      p {
        font-size: 12px;
        font-weight: 400;
        color: #000000;
        line-height: 24px;
        display: flex;
        align-items: center;
        span {
          font-size: 30px;
          font-family: Arial;
          font-weight: 400;
          color: #ff0000;

          font-weight: bold;
          small {
            padding: 0 5px;
          }
        }
      }
      .paybotton {
        height: 50px;
        background: #ff5555;
        border-radius: 8px;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        font-weight: 400;
        color: #fffcfc;
        color: #fff;
        width: 160px;
        cursor: pointer;
        i {
          font-style: normal;
        }
        p {
          display: none;
        }
      }
      .submitting {
        width: 160px;
        height: 50px;
        background: #ddd;
        border-radius: 8px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #888;
      }
    }
  }

  .orderside {
    background: #fff;
    padding: 20px 28px;
    .orderhotel {
      padding: 0 0 20px 0;
      border-bottom: 1px dashed #dbdbdb;
      margin-bottom: 20px;
      img {
        width: 100%;
      }
      h3 {
        font-size: 16px;
        line-height: 36px;
        font-weight: bold;
        font-family: Microsoft YaHei;
        padding: 0 5px;
        color: #222222;
      }
      h4 {
        display: flex;
        justify-content: space-between;
        line-height: 36px;
        padding: 0 5px;
        span {
          color: #ff5555;
        }
      }
      p {
        padding: 0 5px;
        color: #888;
        line-height: 32px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}

.popper-scrollbar-show {
  .el-scrollbar {
    > .el-scrollbar__bar.is-vertical {
      display: block !important;
      // opacity: 1 !important;
    }
  }
}

@media (min-width: 320px) and (max-width: 780px) {
  .ordermain {
    .layout {
      padding-bottom: 100px;
    }

    .bookinfro {
      padding: 20px 15px;
    }
    .bookdate {
      flex-wrap: wrap;
      position: relative;
      .datedetail {
        width: 80%;
      }
      .night {
        position: absolute;
        right: 0;
        top: 40%;
        background: #f1f1f1;
        padding: 8px;
      }
    }
    .custominfro {
      padding: 20px 15px;
      .customphone {
        width: 48%;
      }
    }
  }

  .ordermain .custominfro .costomlist ul li {
    width: 48%;
  }
  .ordermain .paybox .paytotal .paybotton {
    width: 100%;
    position: fixed;
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    height: 70px;
    line-height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    i {
      background: #fed046;
      height: 50px;
      padding: 0 20px;
      line-height: 50px;
      font-weight: bold;
      border-radius: 10px;
    }
    p {
      color: #fff;
      display: block;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        color: #fff;
        padding: 0 15px 0 0;
      }
    }
  }
  .footbox {
    display: none;
  }
  .orderbox {
    .container {
      flex-wrap: wrap;
      position: relative;
      margin-top: 10px;
    }
    .sides {
      display: none;
      width: 100%;
    }
  }
}
</style>
 